var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-app-bar",
    {
      staticClass: "elevation-2",
      attrs: {
        color: "white",
        "max-height": "80px",
        height: _vm.getBarHeight,
        app: "",
        dark: ""
      }
    },
    [
      _c(
        "div",
        {
          staticClass: "d-flex justify-start align-center my-3",
          class: {
            "px-4 md-height": _vm.$vuetify.breakpoint.mdAndUp
          }
        },
        [
          _c("v-img", {
            staticClass: "mr-2",
            style: _vm.$vuetify.breakpoint.mdAndUp
              ? "width: 181px; height: 120px"
              : "width: 140px; height: 120px",
            attrs: {
              alt: "Logo Image",
              contain: "",
              src:
                "https://d1tacsjrssg33t.cloudfront.net/images/ltt-logo-horizontal.png",
              transition: "scale-transition"
            },
            on: { click: _vm.goToHome }
          })
        ],
        1
      ),
      _c("v-spacer"),
      _c(
        "div",
        { staticClass: "display-guest-toolbar" },
        [
          _vm.isGuestBar
            ? _c("GuestToolbar", { attrs: { isOpen: true } })
            : _vm._e(),
          !_vm.isGuestBar
            ? _c("UserToolbar", { attrs: { isOpen: true } })
            : _vm._e()
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }